import type { RouteObject } from 'react-router'
import { page } from './lazy'

/**
 * Member (voter) route module. OWNER: B2 (add / reorganize member routes here only). Rendered inside PublicLayout.
 *
 *   /o/:orgSlug                    organization landing (description, requirements, Join / Log in)
 *   /o/:orgSlug/join               join flow: details → email code → phone code → summary → Didit
 *   /o/:orgSlug/join/return        Didit callback (WEB_PATHS.verifyReturn) → registration status
 *   /o/:orgSlug/status             registration status (registration token in localStorage)
 *   /o/:orgSlug/account            create the account: password + 12 words (after approval)
 *   /o/:orgSlug/login              member login (email + password ⇒ auth verifier); `?next=` deep links
 *   /o/:orgSlug/home               member home: open / upcoming / past votings
 *   /o/:orgSlug/recover            account recovery with the 12 words
 *   /o/:orgSlug/profile            locality update, email preferences, delete my data, logout
 *   /o/:orgSlug/privacy            privacy notice with the organization's own choices (WEB_PATHS.privacy)
 *   /o/:orgSlug/v/:votingSlug      voting page: ballot, revote, vote status, results (invitation links)
 *   /unsubscribe#token=…           email opt-out (footer link of every email)
 *   /privacy                       generic privacy notice
 *
 * `:votingSlug` is the API `electionSlug`. The server builds these URLs with WEB_PATHS (@de/shared routes.ts):
 * keep them in sync.
 */
export const memberRoutes: RouteObject[] = [
  {
    path: 'o/:orgSlug',
    lazy: page(() => import('~/pages/member/MemberLayout')),
    children: [
      { index: true, lazy: page(() => import('~/pages/member/OrgLandingPage')) },
      { path: 'join', lazy: page(() => import('~/pages/member/JoinPage')) },
      { path: 'join/return', lazy: page(() => import('~/pages/member/StatusPage')) },
      { path: 'status', lazy: page(() => import('~/pages/member/StatusPage')) },
      { path: 'account', lazy: page(() => import('~/pages/member/AccountPage')) },
      { path: 'login', lazy: page(() => import('~/pages/member/LoginPage')) },
      { path: 'home', lazy: page(() => import('~/pages/member/HomePage')) },
      { path: 'recover', lazy: page(() => import('~/pages/member/RecoverPage')) },
      { path: 'profile', lazy: page(() => import('~/pages/member/ProfilePage')) },
      { path: 'privacy', lazy: page(() => import('~/pages/member/OrgPrivacyPage')) },
      { path: 'v/:votingSlug', lazy: page(() => import('~/pages/member/VotingPage')) },
    ],
  },
  { path: 'unsubscribe', lazy: page(() => import('~/pages/member/UnsubscribePage')) },
  { path: 'privacy', lazy: page(() => import('~/pages/PrivacyPage')) },
]
